module.exports = __webpack_public_path__ + "static/img/exclusive-modal-bg-1.301e425.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/exclusive-modal-bg-1.png
// module id = 960
// module chunks = 119